'use client'

import React, { useRef, useEffect } from 'react'

export interface ProgressIndicatorProps {
    goal: number
    progression: number
    label: string
    showLabel?: boolean
}

export const ProgressIndicator = ({ goal, progression, label, showLabel = true }: ProgressIndicatorProps) => {
    const domEl = useRef<HTMLDivElement>(null)
    const previousProgressFactor = useRef<number>(0)

    /** set the css custom properties "--progress-factor" and "--duration-factor" on the dom element when the progression value changes */
    const updateProgression = () => {
        let progressFactor = progression / goal
        progressFactor = progressFactor === Infinity || !progressFactor ? 0 : progressFactor

        domEl.current?.style.setProperty('--progress-factor', `${progressFactor}`)
        domEl.current?.style.setProperty(
            '--duration-factor',
            `${Math.abs(progressFactor - previousProgressFactor.current)}`,
        )

        previousProgressFactor.current = progression / goal
    }

    useEffect(() => {
        updateProgression()
    }, [goal, progression])

    const $progress = (
        <progress
            max={goal}
            value={progression}
            aria-label={!showLabel ? label : undefined}
            className="sr-only"
        ></progress>
    )

    return (
        <div>
            <div className={`w-full mb-1 flex flex-row ${showLabel ? 'justify-between' : 'justify-end'}`}>
                {showLabel ? (
                    <label>
                        {label}
                        {$progress}
                    </label>
                ) : (
                    $progress
                )}
                <span>
                    {progression}/{goal}
                </span>
            </div>
            <div className="w-full h-1 bg-shade-opacity-200">
                <div ref={domEl} className="progression bg-accent-default h-full"></div>
            </div>
        </div>
    )
}
